import { computed } from "vue";

export default {
  data() {
    return {
      tenantId: this.realm,
      apiUrl: this.digitalTwinDataDefinitionConfig.api,
    };
  },
  created() {},
  provide() {
    return {
      modelDT: computed(() => this.modelDT),
    };
  },
  methods: {
    setDataSourceAssociation(data) {
      const indexEditEntity = this.modelDT.modelGraph.nodes.findIndex(
        (e) => e.id == this.editEntity.id,
      );
      this.modelDT.modelGraph.nodes[indexEditEntity].data.bindings = undefined;
      this.axios
        .post(
          this.apiUrl + "/" + this.tenantId + "/models/test-connection",
          data,
          this.opts,
        )
        .then(() => {
          this.modelDT.modelGraph.nodes[indexEditEntity].data.bindings = data;
          this.editEntity = undefined;

          this.snackbarEvent(true, this.$t("strings.test-connection-success"));
        })
        .catch((err) => {
          this.setError(err, false);
        });
    },
    resetDataSourceAssociation() {
      const indexEditEntity = this.modelDT.modelGraph.nodes.findIndex(
        (e) => e.id == this.editEntity.id,
      );
      if (this.modelDT.modelGraph.nodes[indexEditEntity].data?.bindings) {
        delete this.modelDT.modelGraph.nodes[indexEditEntity].data.bindings;
      }
    },
    async saveModel() {
      if (this.modelDT) {
        try {
          const sessionStorageModelObject = this.getModelToSessionStorage();
          sessionStorageModelObject.modelGraph = this.modelDT.modelGraph;
          const response = await this.axios.post(
            this.apiUrl + "/" + this.tenantId + "/models",
            sessionStorageModelObject,
            this.opts,
          );

          if (response?.data) {
            this.saveModelToSessionStorage({
              ...sessionStorageModelObject,
              ...response.data,
            });

            this.isChangedModel = false;

            this.snackbarEvent(true, this.$t("strings.save-model-success"));

            await new Promise((resolve) => setTimeout(resolve, 1500));
          }
        } catch (error) {
          this.setError(error, false, undefined, true);
          throw error;
        }
      }
    },
    async continueModel() {
      try {
        if (this.hasPermission) {
          await this.saveModel();
        }
        this.routeTo(`/editor/conversion`);
      } catch (error) {
        console.error(error);
      }
    },
    getModelToSessionStorage() {
      return JSON.parse(sessionStorage.getItem("digital-twin-model"));
    },
    saveModelToSessionStorage(data) {
      sessionStorage.setItem("digital-twin-model", JSON.stringify(data));
      this.modelDT = data;
    },

    async openDialogJsonProperty(object) {
      try {
        let jsonPath;
        if (object?.jsonPath) {
          jsonPath = object.jsonPath;
          delete object.jsonPath;
        }
        const response = await this.axios.post(
          this.apiUrl + "/" + this.tenantId + "/models/test-connection",
          object,
          this.opts,
        );

        if (response?.data?.data) {
          this.dialogJsonProperty = true;
          this.jsonData = response.data.data;
          this.initJsonPath = jsonPath != "$." ? jsonPath : undefined;
        }
      } catch (error) {
        this.setError(error, false, undefined, true);
      } finally {
        this.hideLoader();
      }
    },

    snackbarEvent(value, text) {
      this.snackbar = value;
      this.snackbarText = text;
    },
    //Abort the model creation
    abortModel() {
      sessionStorage.removeItem("digital-twin-model");
      this.routeTo(`/dts`);
    },
    //Goes to a new path
    routeTo(newPath) {
      this.$router.push({
        path: newPath,
      });
    },
  },
};
